import type { LimitsEnrichItem } from "../../api/limitsEnrichItem";
import {
  formatEnrichAmount,
  formatEnrichPrice,
  enrichActiveLabel,
  enrichTypeLabel,
} from "../LimitsEnrichItemModal/limitsEnrichItemForm";
import "../RequestTable/RequestTable.scss";

interface LimitsEnrichItemTableProps {
  data: LimitsEnrichItem[];
  onRowClick: (id: string) => void;
}

export const LimitsEnrichItemTable = ({ data, onRowClick }: LimitsEnrichItemTableProps) => (
  <div className="request-table-wrapper">
    <div className="request-table-card">
      <table className="request-table">
        <thead>
          <tr>
            <th>Тип проверки</th>
            <th>Размер пакета</th>
            <th>Цена</th>
            <th>Статус</th>
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan={4} className="request-table-empty">
                Нет данных
              </td>
            </tr>
          ) : (
            data.map((item) => (
              <tr
                key={item.id}
                className="request-table-row-clickable"
                onClick={() => item.id && onRowClick(item.id)}
              >
                <td>{enrichTypeLabel(item.checkType)}</td>
                <td>{formatEnrichAmount(item.amount)}</td>
                <td>{formatEnrichPrice(item.price)}</td>
                <td>
                  <span
                    className={`request-table-status${
                      item.active === false ? " request-table-status--inactive" : ""
                    }`}
                  >
                    {enrichActiveLabel(item.active)}
                  </span>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  </div>
);
